import React, { Fragment } from 'react'
import { connect } from '@cerebral/react'
import { state } from 'cerebral/tags'
import { css } from 'aphrodite'
import { Header } from '../Header'
import { t } from '@billes/translator-client'
import PillHolder from '../pillHolder'
import themes from '../themes'

const Single = connect(
  {
    fileTypes: state`media.filter.fileTypes.*`
  },
  ({ fileTypes, theme }) => {
    const styles = themes[theme]
    return (
      <div className={css(styles.container)}>
        <Fragment>
          <Header
            theme={theme}
            label={t('bms.media.filterMenu.headings.fileTypes')}
            renderBeforeDelimeter={() => null}
          />
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <PillHolder
              path={'media.filter.fileTypes'}
              theme={theme}
              editMode
              type={'fileTypes'}
            />
          </div>
        </Fragment>
      </div>
    )
  }
)

export default Single



// WEBPACK FOOTER //
// ./src/components/FilterMenu/Section/Single/single.js